import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import React from 'react';
import CustomCheckbox from '../CustomCheckbox';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const MembersListTable = ({ managers, handleChange}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <TableContainer className="table" sx={{ mt: '10px', borderRadius: '5px' }}>
      <Table size="small" aria-label="a dense table">
        <TableHead
          sx={{
            '& .MuiTableRow-root th:first-child': {
              borderTopLeftRadius: '10px',
              borderBottomLeftRadius: '10px',
            },
            '& .MuiTableRow-root th:last-child': {
              borderTopRightRadius: '10px',
              borderBottomRightRadius: '10px',
            },
            background: '#ECECEC',
          }}>
          <TableRow>
            <TableCell align="center">
              <CustomCheckbox
                color="primary"
                name="allSelect"
                checked={!managers?.content?.some(manager => manager.isChecked !== true)}
                onChange={handleChange}
              />
            </TableCell>
            <TableCell align="center">{t('Number')}</TableCell>
            <TableCell align="center">{t('Name')}</TableCell>
            <TableCell align="center">{t('ID')}</TableCell>
            <TableCell align="center">{t('Gender')}</TableCell>
            <TableCell align="center">{t('Age')}</TableCell>
            <TableCell align="center">{t('Phone number')}</TableCell>
            <TableCell align="center">{t('Date of joining')}</TableCell>
            {/* <TableCell align="center">{t('Acception')}</TableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
          {managers &&
            managers?.content?.map((manager, index) => {
              const labelId = `enhanced-table-checkbox-${index}`;
              return (
                <TableRow
                  role="checkbox"
                  component={Link}
                  // to={`/corp/${manager.id}`}
                  key={index}
                  sx={{
                    '&:hover': { color: '#5a5a5a !important' },
                    '.css-1d46hnn-MuiTableCell-root': {
                      padding: '1px',
                    },
                    textDecoration: 'none',
                    height: '40px',
                  }}>
                  <TableCell padding="checkbox" align="center">
                    <CustomCheckbox
                      name={manager.username + manager.memberId}
                      checked={manager?.isChecked || false}
                      onChange={handleChange}
                    />
                  </TableCell>
                  <TableCell
                    id={labelId}
                    scope="row"
                    padding="none"
                    align="center"
                    onClick={e => {
                      e.preventDefault();
                      navigate(`/members/${manager.memberId}`);
                    }}>
                    {((managers.number-1) * managers.size) + index + 1}
                  </TableCell>
                  <TableCell
                    id={labelId}
                    scope="row"
                    padding="none"
                    align="center"
                    onClick={e => {
                      e.preventDefault();
                      navigate(`/members/${manager.memberId}`);
                    }}>
                    {manager.name}
                  </TableCell>
                  <TableCell
                    id={labelId}
                    scope="row"
                    padding="none"
                    align="center"
                    onClick={e => {
                      e.preventDefault();
                      navigate(`/members/${manager.memberId}`);
                    }}>
                    {manager.username}
                  </TableCell>
                  <TableCell
                    id={labelId}
                    scope="row"
                    padding="none"
                    align="center"
                    onClick={e => {
                      e.preventDefault();
                      navigate(`/members/${manager.memberId}`);
                    }}>
                    {t(manager.gender)}
                  </TableCell>
                  <TableCell
                    id={labelId}
                    scope="row"
                    padding="none"
                    align="center"
                    onClick={e => {
                      e.preventDefault();
                      navigate(`/members/${manager.memberId}`);
                    }}>
                    {manager.age}
                  </TableCell>
                  <TableCell
                    id={labelId}
                    scope="row"
                    padding="none"
                    align="center"
                    onClick={e => {
                      e.preventDefault();
                      navigate(`/members/${manager.memberId}`);
                    }}>
                    {manager.phoneNumber}
                  </TableCell>
                  <TableCell
                    sx={{
                      color:
                        {
                          APPROVED: '#0275FC',
                          REFUSED: '#FF3A29',
                          APPROVAL_PENDING: '#000',
                          WITHDREW: '#000',
                        }[manager.status] || 'defaultColor', // Use a fallback color if status is unknown
                    }}
                    id={labelId}
                    scope="row"
                    padding="none"
                    align="center"
                    onClick={e => {
                      e.preventDefault();
                      navigate(`/members/${manager.memberId}`);
                    }}>
                    {t(manager.registeredDate)}
                  </TableCell>
                  {/* <TableCell
                    sx={{
                      color:
                        {
                          APPROVED: '#0275FC',
                          REFUSED: '#FF3A29',
                          APPROVAL_PENDING: '#000',
                          WITHDREW: '#000',
                        }[manager.status] || 'defaultColor', // Use a fallback color if status is unknown
                    }}
                    id={labelId}
                    scope="row"
                    padding="none"
                    align="center"
                    onClick={e => {
                      e.preventDefault();
                      navigate(`/members/${manager.memberId}`);
                    }}>
                    {t(manager.status ? 'Agree' : 'Disagree')}
                  </TableCell> */}
                </TableRow>
              );
            })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default MembersListTable;
